import { useContext } from 'react';
import { PolicyContext } from './PolicyContext';
import { PolicyDispatchContext } from './PolicyDispatchContext';
import { IPolicyContextState } from './state/IPolicyContextState';
import { TPolicyActionDispatch } from './actions/TPolicyActionDispatch';

export const usePolicyContext = (): [IPolicyContextState, TPolicyActionDispatch] => {
  const state = useContext(PolicyContext);
  const dispatch = useContext(PolicyDispatchContext);
  return [state, dispatch];
};
